/**
 * Feature flags — build-time toggles read from Vite env vars.
 *
 * Vite inlines `import.meta.env.VITE_*` values at BUILD time (they're
 * baked into the JS bundle), so each environment picks up its own flag
 * values from its own build. Change a flag = redeploy that environment.
 *
 * Flags are documented alongside their env var so ops knows what each
 * one does without diving into the code.
 */

/**
 * DEV-46921 — engineer Home tab (favourites, recently purchased).
 *
 * Enabled in all environments.
 *
 * Env var: `VITE_FAVOURITES_HOME_TAB_ENABLED`
 *   all environments → "true"
 */
export const HOME_TAB_ENABLED =
  import.meta.env.VITE_FAVOURITES_HOME_TAB_ENABLED === 'true'

/**
 * Landing destination once an engineer has a working postcode (after login or
 * after changing location).
 *
 * Search is the default landing (CU ticket — overrides the earlier DEV-46921
 * Home landing). The Home tab is still reachable from the bottom nav when
 * `HOME_TAB_ENABLED`; it is simply no longer the post-login / post-postcode
 * destination. Shared by the postcode-entry screen (JobSetup) and the Change
 * Location drawer so both agree on where "start searching" goes.
 */
export const POST_POSTCODE_LANDING = 'search'
